import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/teuteuf-games/_components/TeuteufGamesContent.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/game/templates/index.tsx")